import Vuex from 'vuex';
import Vue from 'vue';
import AdminStore from "./AdminStore";
import SnackbarStore from "./SnackbarStore";
import createPersistedState from 'vuex-persistedstate'
import BlogStore from "@/store/BlogStore";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        admin: AdminStore,
        snackbar: SnackbarStore,
        blog: BlogStore,
    },
    plugins: [createPersistedState()],
});
